import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TEArticleList from '@/components/te.article.list';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export interface PriceSet {
    priceItem: TEPrice;
    quantity: number;
    articleId: string;
}

interface priceItem {
    artNo: string;
    quantity: number;
    basePrice: string;
    yourPrice: string;
}

export interface PriceResponse {
    items: priceItem[];
}

export default class TEPrice extends TKCustomElementFactory {
    asyncUrl?: string;
    article?: HTMLElement;
    articleId?: string;
    quantityField?: HTMLInputElement;
    articleList?: TEArticleList;
    yourPriceField?: HTMLElement;
    eventDispatcher?: number;
    orderQuanity?: HTMLInputElement;

    constructor() {
        super();

        this.asyncUrl = this.getAttribute('data-tk-async-url') || undefined;
        this.articleId = this.getAttribute('data-tk-article-id') || undefined;
        this.article = this.closest('article') || undefined;
        this.quantityField = this.article?.querySelector('input.basket-button-quantity') || undefined;
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.yourPriceField = this.querySelector('[data-tk-yourprice]') || undefined;
        this.orderQuanity = this.querySelector('[data-tk-quanity]') || undefined;
    }

    connectedCallback(): void {
        if (!this.article || !this.asyncUrl || !this.articleId || !this.yourPriceField)
            throw new Error('TEPrice: missing data');
        if (this.articleList) {
            this.sendDataToArticleList();
        }

        this.registerListener();
    }

    sendDataToArticleList() {
        const priceSet: PriceSet = {
            priceItem: this,
            quantity: Number(this.quantityField!.value) || 1,
            articleId: this.articleId!,
        };

        this.articleList!.addPrice(priceSet);
    }

    registerListener() {
        const action = this.getPrice.bind(this);
        this.pushListener({ event: 'keydown', element: this.quantityField!, action });

        const quantityButtons = this.article!.querySelectorAll('button[data-op-qtychange]');
        const btnAction = this.getNewQuantity.bind(this);
        quantityButtons.forEach((btn) => {
            this.pushListener({ event: 'mouseup', element: btn, action: btnAction });
        });
    }

    getNewQuantity() {
        if (this.eventDispatcher) {
            clearTimeout(this.eventDispatcher);
        }
        this.eventDispatcher = setTimeout(() => {
            this.getPrice();
        }, 500);
    }

    getPrice(): void {
        const quantity = this.quantityField!.value;
        const payload = {
            quantity,
            artNo: this.articleId!,
        };

        fetchRequest({
            requestURL: this.asyncUrl!,
            payload,
            resolveHandler: this.handleResponse.bind(this),
        });
    }

    handleResponse(response: TKResponse<PriceResponse>): void {
        if (!response.success) return;

        const yourPrice = response.dataAsJson.items[0]!.yourPrice;

        this.insertPrice(yourPrice);
    }

    insertPrice(yourPrice: string, orderQuanity?: string, defaultQuanity?: string) {
        this.yourPriceField!.innerHTML = '';
        this.yourPriceField!.insertAdjacentText('beforeend', yourPrice);

        if (orderQuanity) {
            this.orderQuanity!.innerHTML = '';
            this.orderQuanity!.insertAdjacentText('beforeend', orderQuanity);
        }

        if (this.quantityField && defaultQuanity) {
            this.quantityField.value = defaultQuanity;
        }


    }
}
